import { Alert, Slide, Snackbar } from "@mui/material";
import React from "react";

function SlideTransition(props) {
  return <Slide {...props} direction="down" />;
}

export default function Notification(props) {
  const { notify, setNotify } = props;
  const handleClose = (event, reason) => {
    setNotify({ ...notify, isOpen: false });
  };
  return (
    <Snackbar
      open={notify.isOpen}
      autoHideDuration={1000}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      onClose={handleClose}
      TransitionComponent={SlideTransition}
    >
      <Alert severity={notify.type || "info"} onClose={handleClose}>
        {notify.message}
      </Alert>
    </Snackbar>
  );
}
